"use client";
import React from 'react';
import { TweetProps, useTweet } from "react-tweet";
import {
  MagicTweet,
  TweetNotFound,
  TweetSkeleton,
} from "../ui/tweet";

export const ClientTweetCard: React.FC<TweetProps & { className?: string }> = ({
  id,
  apiUrl,
  fallback = <TweetSkeleton />,
  components,
  fetchOptions,
  onError,
  ...props
}) => {
  const { data, error, isLoading } = useTweet(id, apiUrl, fetchOptions);

  if (isLoading) return <>{fallback}</>;
  if (error || !data) {
    const NotFound = components?.TweetNotFound || TweetNotFound;
    const errorObj = error || new Error('No tweet data available');
    return <>{<NotFound error={onError ? onError(errorObj) : errorObj} />}</>;
  }

  return <>{<MagicTweet tweet={data} components={components} {...props} />}</>;
};
